import {
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  SelectChangeEvent,
  OutlinedInput,
  Checkbox,
  ListItemText
} from '@mui/material';

interface IProps {
  placeholder: string;
  menuItems: Array<{ displayName: string; id: string }>;
  selected: string[];
  setSelected: (selected: string[]) => void;
}

function MultiSelectAll({
  placeholder,
  menuItems,
  selected,
  setSelected
}: IProps): JSX.Element {
  const handleChange = (event: SelectChangeEvent<typeof selected>): void => {
    const {
      target: { value }
    } = event;
    if (value.includes('All') && !selected.includes('All')) {
      setSelected(menuItems.map((item) => item.id));
    } else {
      setSelected(
        typeof value === 'string'
          ? value.split(',').filter((item) => item !== 'All')
          : value.filter((item) => item !== 'All')
      );
    }
  };

  const getDisplayNames = (items: string[]): string => {
    return menuItems
      .filter((item) => items.includes(item.id))
      .map((item) => item.displayName)
      .join(', ');
  };

  return (
    <FormControl
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: '8px',
          maxHeight: '48px',
          fontSize: '16px'
        }
      }}
      fullWidth
    >
      <InputLabel
        sx={{
          fontFamily: 'Be Vietnam Pro',
          fontSize: '16px',
          fontWeight: '500',
          color: '#5F6368',
          opacity: 1
        }}
      >
        {placeholder}
      </InputLabel>
      <Select
        multiple
        value={selected ?? []}
        onChange={handleChange}
        input={<OutlinedInput label={placeholder} />}
        renderValue={(selectedItems) => {
          if (selectedItems.includes('All')) return 'All';
          return getDisplayNames(selectedItems);
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              '&::-webkit-scrollbar': {
                width: '7px',
                background: 'rgba(217, 217, 217, 0.51)'
              },
              '&::-webkit-scrollbar-thumb': {
                borderRadius: '10px',
                backgroundColor: '#aaa'
              },
              '&::-webkit-scrollbar-thumb:hover': {
                backgroundColor: '#999'
              }
            },
            style: {
              width: 'auto'
            }
          }
        }}
      >
        {menuItems.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            <Checkbox checked={selected?.includes(item.id)} />
            <ListItemText primary={item.displayName} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default MultiSelectAll;
